import { NotificationLinkTypeEnum } from '@inter-ikea-kompis/enums';
import { ServiceException } from '@inter-ikea-kompis/exceptions';
import ServiceFetch from '../../utilities/ServiceFetch.js';
/**
 * This class is used for sending a saved planner configuration to a user through email.
 */
export default class DexfNotificationService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     * @param options.dexfApiKey DEXF API key.
     */
    constructor(options) {
        this.endpoint = options.endpoint;
        this.dexfApiKey = options.dexfApiKey;
    }
    /**
     * Sends an email with a configuration to a user.
     *
     * @param options Options.
     * @param options.vpcCode Vpc code.
     * @param options.emailAddress Email address.
     * @param options.linkType Destination for the link. Planner or pickinglist.
     * @param options.storeId Store ID. Configurable for pickinglist.
     * @returns Sent notification status.
     */
    async sendNotification(options) {
        const preparedMessageUrl = await this.prepareMessage(options.vpcCode, options.linkType, options.storeId);
        if (!preparedMessageUrl) {
            throw new ServiceException('Failed to get preparedMessageUrl. Service did not return url.');
        }
        const response = await ServiceFetch.json(preparedMessageUrl, {
            credentials: 'same-origin',
            method: 'POST',
            headers: this.getHeaders(),
            body: this.getBody(options.emailAddress)
        });
        if (response.jobId === undefined) {
            throw new ServiceException('Failed to get jobId. Service did not return jobID.');
        }
    }
    /**
     * Prepares message template and returns prepared reference object.
     *
     * @param vpcCode VpcCode ex '34WY5'.
     * @param linkType Destination for the link. Planner or pickinglist.
     * @param storeId Store ID. Configurable for pickinglist.
     * @returns Prepared message url.
     */
    async prepareMessage(vpcCode, linkType, storeId) {
        const baseUrl = this.endpoint;
        let url = `${baseUrl}/${vpcCode}/prepare?type=email&linkType=${linkType}`;
        if (storeId && NotificationLinkTypeEnum.pickinglist === linkType) {
            url += `&storeCode=${storeId}`;
        }
        const response = await ServiceFetch.json(url, {
            credentials: 'same-origin',
            method: 'GET',
            headers: this.getHeaders()
        });
        if (response._links) {
            return decodeURI(response._links.send.href);
        }
        return null;
    }
    /**
     * Returns body for notification.
     *
     * @param emailAddress Email address.
     * @returns Stringified body.
     */
    getBody(emailAddress) {
        return JSON.stringify({
            to: emailAddress
        });
    }
    /**
     * Returns headers.
     *
     * @returns Headers.
     */
    getHeaders() {
        return {
            'dexf-api-key': this.dexfApiKey,
            'content-type': 'application/json'
        };
    }
}
//# sourceMappingURL=DexfNotificationService.js.map